export enum ProcessType {
    //default null
    NULL_VALUE="",
    //original values 
    APPLICATION = "APPLICATION",
    BEHAVIOURAL = "BEHAVIOURAL",
    Application = "Application",
    Behavioural = "Behavioural",
    BEHAVIORAL = "BEHAVIORAL"
}